/**
 * Centralized overlay styling configuration
 * Use this to adjust overlay backgrounds, opacity, and animations across the app
 */

export const OVERLAY_CONFIG = {
  // Background overlay opacity (0-1)
  backgroundOpacity: 0.9,

  // Fade-in animation duration
  fadeInDuration: '0.5s',

  // Fade-in animation easing
  fadeInEasing: 'ease-in-out',

  // Background color (will be combined with opacity)
  backgroundColor: 'rgba(0, 0, 0, 0.9)', // 90% black
};

export default OVERLAY_CONFIG;
